// extracted by mini-css-extract-plugin
export default {"content":"RichTextContent_content__Y1AkW"};